module.exports = __webpack_public_path__ + "/login_ui/img/mh-38903f2793339fc69a48678c6ba8eaf6.svg";